export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Ver Cotas" },
    { key: "2", label: "Editar Apartamento" },
    { key: "3", label: "Ver Proprietário" },
  ];
};
